/* ===== MATERIAL COLOR INDICATOR DOTS ===== */
(function () {
  const MATERIAL_MAP = {
    silver: ['sterling silver', 'white gold'],
    gold: ['gold vermeil', 'yellow gold'],
    rose: ['rose gold']
  };

  function getColorFamily(text) {
    const lower = text.toLowerCase().trim();
    if (lower.includes('rose gold')) return 'rose';
    if (lower.includes('white gold')) return 'silver';
    if (lower.includes('gold')) return 'gold';
    if (lower.includes('platinum')) return 'silver';
    if (lower.includes('sterling silver')) return 'silver';
    if (lower.includes('silver')) return 'silver';
    return null;
  }

  function tagOptions() {
    document.querySelectorAll('label.popover__value-option').forEach(label => {
      const span = label.querySelector('span');
      if (!span || label.dataset.materialColor) return;
      const family = getColorFamily(span.textContent);
      if (family) {
        label.dataset.materialColor = family;
        span.dataset.materialColor = family;
      }
    });
  }

  function tagSelectButtons() {
    document.querySelectorAll('button.select > span').forEach(span => {
      if (span.dataset.materialColor) span.removeAttribute('data-material-color');
      const family = getColorFamily(span.textContent);
      if (family) span.dataset.materialColor = family;
    });
  }

  function init() {
    tagOptions();
    tagSelectButtons();
  }

  // Run on load
  init();

  // Re-run when variant changes (updates the button text)
  document.addEventListener('variant:change', function () {
    setTimeout(tagSelectButtons, 50);
  });

  // Re-run when popovers open (options may be lazily rendered)
  new MutationObserver(function () {
    tagOptions();
    tagSelectButtons();
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ===== META PIPELINE — Handle-Driven Feature System ===== */
/*
  Architecture:
    1. Reads product data from #meta-pipeline-root data attributes
    2. Looks up handle in MP_CONFIG registry
    3. Activates listed feature modules, passing product data + mount zone
  
  Adding a new product:
    Add entry to MP_CONFIG with handle as key, features array as value.
  
  Adding a new feature type:
    Add renderer function to MP_FEATURES object.
    Add CSS to custom.css scoped under #meta-pipeline-root.
*/
(function() {
  var root = document.getElementById('meta-pipeline-root');
  if (!root) return;

  /* ---- Product data from Liquid data attributes ---- */
  var PRODUCT = {
    handle: root.dataset.handle,
    id: root.dataset.productId,
    type: root.dataset.productType,
    tags: (root.dataset.tags || '').split('|||').map(function(t) { return t.trim(); }).filter(Boolean),
    price: parseInt(root.dataset.price, 10),
    comparePrice: parseInt(root.dataset.comparePrice, 10) || 0,
    available: root.dataset.available === 'true',
    variantId: root.dataset.variantId,
    variantsCount: parseInt(root.dataset.variantsCount, 10),
    currency: root.dataset.currency || 'USD'
  };

  /* ---- Mount zones ---- */
  var ZONES = {
    offers: document.getElementById('mp-zone-offers'),
    trust: document.getElementById('mp-zone-trust'),
    timeline: document.getElementById('mp-zone-timeline'),
    social: document.getElementById('mp-zone-social')
  };

  /* ===========================================================
     CONFIG REGISTRY
     Key: product handle
     Value: object with feature flags and feature-specific params
     
     Example entry:
     'my-product-handle': {
       offers: {
         type: 'bundle',             // which offer renderer to use
         tiers: [
           { qty: 1, label: 'Buy 1', discount: '50% Off' },
           { qty: 2, label: 'Buy 2', discount: '60% Off', priceMultiplier: 0.8 },
           { qty: 3, label: 'Buy 3', discount: '70% Off', priceMultiplier: 0.65 }
         ]
       },
       trust: {
         badges: ['no-tarnish', 'free-shipping', 'female-founded']
       },
       timeline: {
         enabled: true,
         shipDays: [1, 2],
         deliverDays: [5, 8]
       },
       social: {
         reviewCount: '10K+',
         label: '5-STAR REVIEWS'
       }
     }
  =========================================================== */
  var MP_CONFIG = {
    'the-boundless-sisterhood-ring': {
      offers: {
        type: 'bundle',
        tiers: [
          { qty: 1, label: 'Buy 1', discount: '50% Off' },
          { qty: 2, label: 'Buy 2', discount: '60% Off', priceMultiplier: 0.84 },
          { qty: 3, label: 'Buy 3', discount: '70% Off', priceMultiplier: 0.77 }
        ]
      },
      trust: {
        badges: ['no-tarnish', 'free-shipping', 'female-founded']
      },
      timeline: {
        enabled: true,
        shipDays: [1, 2],
        deliverDays: [6, 10]
      },
      social: {
        reviewCount: '10K+',
        label: '5-STAR REVIEWS'
      }
    }
  };

  /* ===========================================================
     FEATURE RENDERERS
     Each function receives (zone, config, product) and renders
     its UI into the zone element.
  =========================================================== */
  var MP_FEATURES = {

    /* ---- BUNDLE / QUANTITY BREAK OFFERS ---- */
    offers: function(zone, config, product) {
      if (!zone || !config) return;

      if (config.type === 'bundle') {
        var html = '<div class="mp-bundle">';
        config.tiers.forEach(function(tier, i) {
          var isDefault = i === 0;
          var tierPrice = tier.priceMultiplier
            ? Math.round(product.price * tier.priceMultiplier * tier.qty)
            : product.price * tier.qty;
          var tierCompare = tier.priceMultiplier
            ? product.price * tier.qty
            : null;

          html += '<label class="mp-bundle__tier' + (isDefault ? ' mp-bundle__tier--active' : '') + '">'
            + '<input type="radio" name="mp-bundle-qty" value="' + tier.qty + '"' + (isDefault ? ' checked' : '') + ' class="mp-bundle__radio">'
            + '<span class="mp-bundle__info">'
              + '<span class="mp-bundle__label">' + tier.label + '</span>'
              + '<span class="mp-bundle__discount">' + tier.discount + '</span>'
            + '</span>'
            + '<span class="mp-bundle__price">'
              + formatCents(tierPrice)
              + (tierCompare ? '<span class="mp-bundle__compare">' + formatCents(tierCompare) + '</span>' : '')
            + '</span>'
          + '</label>';
        });
        html += '</div>';
        zone.innerHTML = html;

        /* Tier selection logic */
        zone.querySelectorAll('.mp-bundle__radio').forEach(function(radio) {
          radio.addEventListener('change', function() {
            zone.querySelectorAll('.mp-bundle__tier').forEach(function(t) {
              t.classList.remove('mp-bundle__tier--active');
            });
            this.closest('.mp-bundle__tier').classList.add('mp-bundle__tier--active');
          });
        });
      }
    },

    /* ---- TRUST BADGES ---- */
    trust: function(zone, config, product) {
      if (!zone || !config || !config.badges) return;

      var BADGE_LIBRARY = {
        'no-tarnish': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
          title: 'ABSOLUTELY NO TARNISHING',
          text: 'We only use the highest standards of plating. Extra durable and waterproof — no tarnishing and no green skin.'
        },
        'free-shipping': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>',
          title: 'FREE WORLDWIDE SHIPPING',
          text: 'No matter where you are, we\'ll get it to you — fast and at no extra cost. Every order comes with tracked delivery.'
        },
        'female-founded': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="5"/><path d="M12 13v8"/><path d="M9 18h6"/></svg>',
          title: 'FEMALE FOUNDED & OPERATED',
          text: 'Built by women, for women — our team knows what matters most when it comes to meaningful, lasting jewelry.'
        },
        'lifetime-warranty': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
          title: 'LIFETIME WARRANTY',
          text: 'Every piece is backed by our Lifetime Warranty. If anything goes wrong with craftsmanship or materials, we replace it.'
        },
        'certified': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>',
          title: 'CERTIFIED AUTHENTIC',
          text: 'Every piece ships with an Awareness Avenue Certificate of Authenticity verifying materials and craftsmanship.'
        },
        '250k-customers': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>',
          title: '250,000+ HAPPY CUSTOMERS',
          text: 'Nearly a decade of trust since 2016. Join over a quarter million customers who chose quality without compromise.'
        },
        'hassle-free-returns': {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg>',
          title: '14-DAY HASSLE-FREE RETURNS',
          text: 'Not completely happy? Return any item within 14 days for a full refund. No questions, no friction.'
        }
      };

      var html = '<div class="mp-trust">';
      config.badges.forEach(function(key) {
        var badge = BADGE_LIBRARY[key];
        if (!badge) return;
        html += '<div class="mp-trust__badge">'
          + '<span class="mp-trust__icon">' + badge.icon + '</span>'
          + '<div class="mp-trust__content">'
            + '<strong class="mp-trust__title">' + badge.title + '</strong>'
            + '<p class="mp-trust__text">' + badge.text + '</p>'
          + '</div>'
        + '</div>';
      });
      html += '</div>';
      zone.innerHTML = html;
    },

    /* ---- SHIPPING TIMELINE ---- */
    timeline: function(zone, config, product) {
      if (!zone || !config || !config.enabled) return;

      var today = new Date();
      var orderDate = formatDate(today);

      var shipStart = new Date(today);
      shipStart.setDate(shipStart.getDate() + config.shipDays[0]);
      var shipEnd = new Date(today);
      shipEnd.setDate(shipEnd.getDate() + config.shipDays[1]);

      var deliverStart = new Date(today);
      deliverStart.setDate(deliverStart.getDate() + config.deliverDays[0]);
      var deliverEnd = new Date(today);
      deliverEnd.setDate(deliverEnd.getDate() + config.deliverDays[1]);

      var html = '<div class="mp-timeline">'
        + '<div class="mp-timeline__step">'
          + '<span class="mp-timeline__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span>'
          + '<span class="mp-timeline__label">ORDERED</span>'
          + '<span class="mp-timeline__date">' + orderDate + '</span>'
        + '</div>'
        + '<span class="mp-timeline__line"></span>'
        + '<div class="mp-timeline__step">'
          + '<span class="mp-timeline__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 3 20 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></span>'
          + '<span class="mp-timeline__label">ORDER SHIPS</span>'
          + '<span class="mp-timeline__date">' + formatDate(shipStart) + ' - ' + formatDate(shipEnd) + '</span>'
        + '</div>'
        + '<span class="mp-timeline__line"></span>'
        + '<div class="mp-timeline__step">'
          + '<span class="mp-timeline__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M9 16l2 2 4-4"/></svg></span>'
          + '<span class="mp-timeline__label">DELIVERED</span>'
          + '<span class="mp-timeline__date">' + formatDate(deliverStart) + ' - ' + formatDate(deliverEnd) + '</span>'
        + '</div>'
      + '</div>';
      zone.innerHTML = html;
    },

    /* ---- SOCIAL PROOF BAR ---- */
    social: function(zone, config, product) {
      if (!zone || !config) return;

      var html = '<div class="mp-social">'
        + '<span class="mp-social__count">' + config.reviewCount + '</span>'
        + '<span class="mp-social__label">' + config.label + '</span>'
      + '</div>';
      zone.innerHTML = html;
    }
  };

  /* ---- Helpers ---- */
  function formatCents(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: PRODUCT.currency,
        minimumFractionDigits: 2
      }).format(amount);
    } catch(e) {
      return amount.toFixed(2);
    }
  }

  function formatDate(d) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  /* ===========================================================
     INIT — Look up handle, activate features
  =========================================================== */
  var config = MP_CONFIG[PRODUCT.handle];
  if (!config) return; /* No config for this handle = no features */

  Object.keys(config).forEach(function(featureKey) {
    if (MP_FEATURES[featureKey]) {
      MP_FEATURES[featureKey](ZONES[featureKey], config[featureKey], PRODUCT);
    }
  });

})();